import { getEnv } from "../../AppConfigs";
import { GraphRequestBaseService } from "../GraphRequestBase.service";

const SPSiteId = getEnv("REACT_APP_SP_SITE_ID");
const SPListId = getEnv("REACT_APP_DOCUMENT_TAGS_LIST_ID");

export const documentTagsService = new GraphRequestBaseService(`sites/${SPSiteId}/lists/${SPListId}/items`, [
  "Title",
  "eTagType",
]);
